import {createRouter, createWebHistory} from 'vue-router'
import StyleGuideHome from "./StyleGuideHome.vue";
import Typography from "./Typography.vue";
import ColorEditor from "./ColorEditor.vue";
import ComponentEditor from "./ComponentEditor.vue";

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: '/style-guide',
            redirect: '/style-guide/home',
        },
        {
            path: '/style-guide/home',
            name: 'home',
            component: StyleGuideHome,
        },
        {
            path: '/style-guide/typography',
            name: 'typography',
            component: Typography
        },
        {
            path: '/style-guide/colors',
            name: 'colors',
            component: ColorEditor
        },
        {
            path: '/style-guide/components',
            name: 'components',
            component: ComponentEditor
        }
    ]
})

export default router